export const lang = {
    header:{
        Price:'价格',
        Wallet:'钱包',
        Company:'公司',
        About:'关于我们',
        Team:'团队',
        Blog:'博客',
        Career:'事业',
        Support:'支持',
        Contact:'联系我们',
        helpdesk:'服务台',
        faq:'FAQ',
        Transaction:'交易',
        Dashboard:'币币交易',
        Donwload:'APP下载',
        Login:'登入'
    },
    index:{
        title01:'买卖加密货币',
        tip01:'快速安全的购买或交换150多种加密货币的方法',
        placeholder01:'现在注册',
        send:'购买',
        get:'支付',
        ExchangeNow:'立即购买',
        title02:"世界领先的加密货币交易所",
        tip02:'在几分钟内交易比特币、ETH和其他数百种加密货币',
        name:'名称',
        pirce:'最新价',
        change:'24h涨跌',
        chart:'图表',
        trade:'贸易方式',
        buy:'购买',
        itle03:"24小时统计",
        tip03:'TPEX全球站，最近24小时成交74916473美元，为全球超过130个国家的数千万用户提供安全、可信赖的数字资产管理服务',
        newUser:'新用户',
        regularUser:'普通用户',
        transactionsMade:'交易已完成',
        todayPair:"今天的冠军对",
        visitsToday:'近日访问',
        averageProcessingTime:'Average processing tim平均处理时间e',
        minutes:'分钟',
        title04:'那么，今天带来什么新产品？',
        title04_1:'集成我们的API',
        title04_2:'加入我们的币商计划',
        tip04_1:'项目的白标解决方案，无论是钱包、市场还是服务提供商。进行设置已接受TPEX上列出的100多种加密货币中的任何一种，并获取每笔交易的数据',
        tip04_2:'在您的网页、手机钱包或APP上可以进行购买和出售交易或分享币商计划链接，通过使用任何一种方式进行的每一笔交易，均可获得收益',
        learn:'集成API',
        become:'成为币商',
        easy:'简单',
        easy_des:'创建一个账户，选择您的加密货币，输入你您的收款地址，然后发送您的资金。',
        safe:'安全',
        safe_des:'作为托管交易所，每笔交易的数字资产都有Teleprot平台的托管账户提供支持，任何人无法提币，因此您的资产非常安全。',
        competitive:'竞争的',
        competitive_des:'我们的汇率是实时更新的，您所看到的就是所获得的，没有额外费用。',
        mobileApp:'移动应用',
        donwload_tip01:'获取最佳的移动应用，随时随地的交换或者购买加密货币',
        donwload_tip02:'市场上最优惠的价格',
        donwload_tip03:'验证每笔交易',
        donwload_tip04:'高限制',
        donwload_tip05:'超过150种交易货币',
        donwload_tip06:'用美元、欧元、人民币购买加密货币',
        title05:'让我们直接收到你的来信！',
        address:'地址',
        addressValue:'SERVICES SWAPSPACE INC. \n MSB registration number:  M21739712  \n Main office :  56 HIGH PARK AVE UNIT 406 TORONTO, ON, CANADA M6P2R9',
        fullName:'全名',
        email:'电子邮件',
        placeholder02:'请输入您的名字',
        placeholder03:'请输入您的电子邮件',
        placeholder04:'告诉我们可以为您提供哪些帮助？',
        sendMessage:'发消息',
        showMore:'展示更多'
    },
    footer:{
        company:'公司',
        about:'关于',
        career:'事业',
        affiliate:'会员关系',
        ourPartner:'我们的合作伙伴',
        support:'支持',
        ticket:'票',
        faq:'常见问题',
        blog:'博客',
        helpdesk:'服务台',
        exchangePair:'交换对',
        to:'到',
        socialContact:'社交',
    },
    price:{
        search:'搜索',
        searchCoin:'搜索币种',
        list:'列表',
        grid:'网格',
        tile:'几分钟开始创建一个账号，关联您的银行帐户开始买卖',
        tip:'支持多种最受欢迎的数字货币',
        registerNow:'现在注册',
    },
    wallet:{
        title01:'您所有的数字资产都集中在一个地方',
        tip01:'通过将代币和收藏品存储在您自己的设备上，可以完全控制它们。',
        title02:'多币种支持',
        tip02:'管理BTC，BCH，ETH，ETC，LTC和所有ERC-20代币',
        title03:'一键兑换',
        tip03:'感受NowPay多快好省的兑换体验',
        title04:'安全存储',
        tip04:'多重加密、安全隔离，为你的资产保驾护航',
        title05:'轻松发送和接收加密货币',
        tip05:'可使用NowPay钱包账户向世界上任何人付款',
    },
    team:{
        title01:'想与我们合作？',
        tip01:'我们一直在寻求聘请有才华的人加入我们不断壮大的设计师，工程师和支持人员团队。',
        showDetails:"查看详情",
        title02:'小团队，大梦想',
        tip02:'我们的重点始终是寻找最合适的人。 我们的门槛很高，但是您随时准备迎接挑战。',
        title03:'受到全球数百万企业的信赖'
    },
    career:{
        title01:'我们的我们为您预留了职位价值',
        title02:'在NowPay工作',
        tip02:'我们接受了一个巨大的挑战，并把它作为我们的使命：为世界创造一个开放的金融体系。为了实现这一目标，我们正在建立一支聪明、有创造力、充满激情的乐观主义者团队，这种人在别人看到障碍时看到机会。如果这听起来像你，看看我们的开放角色。',
        title03:'我们的价值',
        tip03:'我们的价值观反映了我们的行为以及我们每天所做的选择。 因此，我们的文化成为我们正在努力建立的世界的典范：透明，快乐，好奇和快速发展。 我们的价值观是NowPay为什么是一个理想的工作场所以及我们为何成功的重要原因。 它们不只是对我们的语言（而且我们有表情符号来证明这一点）。',
        title04:'我们的任务',
        tip04:'我们认为实现我们的使命是在世界上带来更多经济自由，创新，效率和机会均等的最高杠杆方式。 我们团队中的每个成员-每个工程师，设计师，厨房团队成员，律师，作家，支持协调员，招聘人员和产品经理-在帮助我们完成任务中都扮演着重要角色。',
        title05:'选择您的团队',
        occupation01:'业务开发与销售',
        occupation02:'业务发展总监',
        address02:'San Francisco, CA',
        occupation03:'工程-前端',
        occupation04:'营销与传播'
    },
    helpdesk:{
        title:'我们如何为您提供帮助？',
        search:'搜索',
        title01:'常见问题',
        title02:'安全专栏',
        list01:[
            '关于近期部分币种价格波动的风险提示',
            '关于防范假冒“搬砖套利”等各类形式诈骗的风险提示',
            '关于近期币种价格波动及谨防“模式币”炒作的风险提示',
            "常见诈骗套路说明",'如何防止钓鱼攻击'
        ],
        title03:'OTC指引',
        list02:[
            '如何通过网页端购买比特币？',
            '订单出现异常情况如何联系客服？',
            '忘记OTC交易资金密码的处理办法',
            'OTC资产的折算方式','为什么登录后的广告列表不一致？'
        ],
        title04:'费率说明',
        list03:[
            "如何通过网页端购买比特币？",
            "OTC交易手续费如何收取？",
            " ",
            " "
        ],
        title05:"找不到您想要的东西？",
        tip:'让我们来帮助您',
        submit:'提交工单'
    },
    faq:{
        title01:'常见问题解答',
        tip01:'NowPay是一种即时加密货币交易所，可让您快速交换加密货币并使用银行卡购买。 该服务提供了最佳的加密率，并支持超过140种可用于交换的加密货币',
        title02:'NowPay如何工作？',
        tip02:'NowPay的交易算法已集成到最大的加密货币交易平台中，包括Binance，Poloniex，Bittrex等。Tradix在毫秒范围内对平台进行出价和要价，然后选择并建议最佳可用汇率并在 我们的网站。 在实际在区块链上进行交易之前，汇率一直保持近似，这就是为什么交易时的汇率可能与您开始交易时看到的估计汇率略有不同的原因。',
        title03:'我为什么要相信你？',
        tip03:'NowPay是最著名的即时加密货币交易所之一，赢得了来自世界各地超过200万用户的信任。 该服务提供安全，快速的交易，而无需透露用户身份。 我们通过比较各种可靠的交易平台来提供最佳汇率，并与不断增加的140多种加密货币一起使用。',
        list01:[
            '没有存款存储。',
            '即时交流。',
            '每个帐户都受到2要素身份验证和HTTPS协议的保护。',
            '超过200万用户满意。'
        ],
        title04:'NowPay是固定汇率吗？',
        tip04_1:'NowPay应用程序用户将不再受到与加密市场波动相关的风险的影响。 不久，固定汇率交换也将在网络版本上实现。 要锁定当前汇率，用户需要单击锁定图标，这将导致他们获得与屏幕上显示的完全相同的加密量。 该速率固定为15分钟，应该足以进行交换。',
        tip04_2:'另外，对于以浮动汇率进行的所有加密货币到加密货币交易，NowPay会提供最低的0.25％的费用。',
        title05:'不可执行的规定',
        tip05:'如果本网站免责声明中的任何条款根据适用法律被认为是不可执行的，则不会影响本网站免责声明中其他条款的可执行性。',
        title06:'友情链接',
        tip06:'外部链接（指向第三方网页）内容的责任完全由链接页面的运营者承担。',
        title07:'违反以下条款和条件',
        list02:[
            '如果您以任何方式违反这些条款和条件，NowPay保留采取这些措施的权利。',
            'NowPay可能采取了适当的措施来处理违规行为，包括暂停您对网站的访问，暂停您通过NowPay赚取的收入，禁止您访问该网站或对您提起诉讼。'
        ]
    },
    about:{
        title01:'关于NowPay',
        tip01_1:'NowPay 建立在开放式的区块链技术之上，充分利用了它们提供的安全性和透明性，整合转换当今最广泛集成的数字货币。',
        tip01_2:'我们将成为您数字资产转换的受托人和拖管人并消除交换监管风险，您可以使用熟悉的货币定价商品和服务，在交易所和NowPay之间随时移动货币。',
        title02:'TsungHan Yang',
        tip02_1:'Head of NowPay',
        tip02_2:'杨宗翰一直在区块链领域工作。',
        title03:'在NowPay工作',
        tip03:'数字货币正在改变我们使用和思考货币的方式。NowPay是业界最值得信赖的公司，现诚邀您加入我们快速成长的团队。',
        readMore:'查看更多'
    },
    blog:{
        title01:'为什么莱特币需要MimbleWimble?',
        tip01:'Cras chinwag伊顿面包的开裂目标是我说的是一堆旧的tosh烤蛋糕。',
        title02:'当市场走势符合你的预案时，请坚持执行你的交易计划！',
        tip02:'自从6-3日价格从10500下降到9500后，价格再次进入到了漫长的调整洗盘当中。',
        title03:'暴力去杠杆后，比特币在大危机中繁荣',
        tip03:'欧美经济活动受疫情影响基本停止，消费、物流和金融活动的停滞导致 各国金融晋级状态。',
        title04:'比特币七上八下——多空胜负手就在本周',
        tip04:'自从6-3日价格从10500下降到9500后，价格再次进入到了漫长的调整洗盘当中。',
        admin:'管理员',
        title05:'最近贴文',
        tip05_1:'加密货币和spx500走势幻想',
        tip05_2:'BTC日线三角整理已经到了末端',
        tip05_3:'BTC还会继续向上，走势会有艰难',
        title06:'标签',
        tags:[ 'BTC','Dashboard','Financial','Exchange' ]
    },
    dashboard:{
        fav:'自选',
        newPrice:'最新价',
        tradingPair:'交易对',
        change:'涨幅',
        high:'高',
        low:'低',
        volume:'量',
        tape:'盘口',
        marketTrades:'实时交易',
        amount:'数量',
        limit:'限价交易',
        market:'市价交易',
        buyPrice:'买入价',
        buyAmount:'买入量',
        sellPrice:'卖出价',
        sellAmount:'卖出量',
        total:'交易额',
        buy:'立即购买',
        sell:'立即出售',
        price:'价格',
        time:'时间',
        executed:'已成交',
        unexecuted:'未成交',
        action:'操作',
        noRecords:'暂无数据',
        openOrder:'当前委托',
        orderHistory:'历史委托',
        type:'类型'

    }
}